export default function Footer() {
  const links = {
    Services: [
      { label: 'Game Design', href: '#services' },
      { label: 'Art Direction', href: '#services' },
      { label: 'Business Development', href: '#services' },
    ],
    Company: [
      { label: 'Our Team', href: '#team' },
      { label: 'Events', href: '#events' },
      { label: 'Contact', href: '#contact' },
    ],
  };

  return (
    <footer className="relative bg-background-900 border-t border-background-800/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <a href="#hero" className="flex items-center gap-2 text-xl font-bold font-heading text-background-50 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-sm font-bold">C</span>
              Coreloop Partners
            </a>
            <p className="text-sm text-foreground-400 leading-relaxed max-w-sm">
              Turkey&apos;s game industry consultancy. We provide expert guidance to studios in game design, art direction, and business development.
            </p>
          </div>

          {Object.entries(links).map(([title, items]) => (
            <div key={title}>
              <h4 className="text-sm font-bold font-heading text-background-50 mb-4">{title}</h4>
              <ul className="flex flex-col gap-2.5">
                {items.map((item) => (
                  <li key={item.label}>
                    <a
                      href={item.href}
                      className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Coreloop Partners. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-400 hover:text-background-50 hover:bg-background-700 transition-all duration-300 cursor-pointer" aria-label="LinkedIn">
              <i className="ri-linkedin-fill text-lg"></i>
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-400 hover:text-background-50 hover:bg-background-700 transition-all duration-300 cursor-pointer" aria-label="Twitter">
              <i className="ri-twitter-x-line text-lg"></i>
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-400 hover:text-background-50 hover:bg-background-700 transition-all duration-300 cursor-pointer" aria-label="Email">
              <i className="ri-mail-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}